import {
  Receipt as ReceiptIcon,
  Description as DescriptionIcon,
  Verified as VerifiedIcon,
  CalendarMonth as CalendarMonthIcon,
  Dashboard as DashboardIcon,
  DoneAll as DoneAllIcon,
  Visibility as VisibilityIcon,
  Event as EventIcon,
  Groups as GroupsIcon,
  AttachMoney as AttachMoneyIcon,
  BeachAccess as BeachAccessIcon,
  WorkHistory as WorkHistoryIcon,
  Assignment as AssignmentIcon,
  ThumbDown as ThumbDownIcon,
  BookOnline as BookOnlineTwoToneIcon,
  
  Folder as FolderIcon,
  CardGiftcard as CardGiftcardIcon,
  Cake as CakeIcon,
  TaskAlt as TaskAltIcon,
  MenuBook as MenuBookIcon,
  AccountTree as AccountTreeIcon,
  EventBusy as EventBusyIcon,
  People as PeopleIcon,
  Business as BusinessIcon,
  LocalOffer as LocalOfferIcon,
  AssignmentInd as AssignmentIndIcon,
  FlightTakeoff as FlightTakeoffIcon,
  
} from '@mui/icons-material';
import MailIcon from '@mui/icons-material/Mail';


import { ReactComponent as HomeLineIcon } from '../../assets/images/home-line.svg';
import { ReactComponent as Home04Icon } from '../../assets/images/home-04.svg';
import { ReactComponent as UserDownIcon } from '../../assets/images/user-down.svg';
import { ReactComponent as GridIcon } from '../../assets/images/grid.svg';


const createIcon = (IconComponent: React.ElementType, size: string = '1.125rem', color?: string) => {
  return (props: { style?: React.CSSProperties }) => (
    <IconComponent
      style={{
        width: size,
        height: size,
        ...props.style,
        color,
      }}
    />
  );
};

interface MenuIcons {
  [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

const menuIcons: MenuIcons = {
  
  'Mi Portal': HomeLineIcon,
  General: Home04Icon,
  'A mi cargo': UserDownIcon,
  Administración: GridIcon,

  
  'Grupos de notificación': createIcon(GroupsIcon),
  'Registro de Asistencia': createIcon(EventIcon),
  Panel: createIcon(DashboardIcon),
  Marcaciones: createIcon(WorkHistoryIcon),
  Aprobaciones: createIcon(TaskAltIcon),
  Ausencias: createIcon(EventBusyIcon),
  'Grupos de aprobación': createIcon(PeopleIcon),
  'Boletas de Pago': createIcon(ReceiptIcon),
  Contratos: createIcon(DescriptionIcon),
  Constancias: createIcon(VerifiedIcon),
  'Contratos de colaboradores': createIcon(DescriptionIcon),
  'Boletas de pago': createIcon(ReceiptIcon),
  Vacaciones: createIcon(FlightTakeoffIcon),
  'Resumen de Vacaciones': createIcon(BeachAccessIcon, '1.5rem'),
  'Gestión de Licencias': createIcon(AssignmentIcon, '1.5rem'),
  Documentos: createIcon(FolderIcon),
  'Mi ficha': createIcon(AssignmentIndIcon),
  Beneficios: createIcon(CardGiftcardIcon),
  'Mis Prestamos': createIcon(AttachMoneyIcon),
  Cumpleaños: createIcon(CakeIcon),
  Publicaciones: createIcon(BookOnlineTwoToneIcon),
  Organigrama: createIcon(AccountTreeIcon),
  Directorio: createIcon(MenuBookIcon),
  'Aprobar Publicaciones': createIcon(TaskAltIcon),
  Programación: createIcon(CalendarMonthIcon),
  Calendario: createIcon(CalendarMonthIcon),
  Áreas: createIcon(BusinessIcon),
  Cupones: createIcon(LocalOfferIcon),
  'Configuración de tipos de ausencia': createIcon(LocalOfferIcon),
  Aprobación: createIcon(DoneAllIcon, '1.5rem', 'white'),
  Gestión: createIcon(VisibilityIcon, '1.5rem', 'white'),
  Prestamos: createIcon(AttachMoneyIcon),
  'Emails Rechazados': createIcon(ThumbDownIcon),
  'Configuración de Emails': createIcon(MailIcon),
};

export default menuIcons;